import { TEMPLATES_REQUEST_LIMIT } from 'templates/pages/Categories/constants';
import { TemplatesSearchResponseModel } from './types';

export function cleanQueryObject(obj: { [key: string]: unknown }): Record<string, string> {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([key, value]) => value && key !== 'page')
      .map(([key, value]) => [key, String(value)]),
  );
}

export default async function getSearchedTemplates(
  searchParams: URLSearchParams,
  headers?: any,
): Promise<TemplatesSearchResponseModel> {
  const query = {
    q: searchParams.get('q') || '',
    page: searchParams.get('page') || '1',
    is_paid: searchParams.get('is_paid') || '',
    colors: searchParams.get('colors') || '',
    orientations: searchParams.get('orientations') || '',
    ratio: searchParams.get('size') || '',
    sort: searchParams.get('sort') || '',
  };

  const searchTerms = [query.q];
  const theme = searchParams.get('theme');

  if (theme) {
    searchTerms.push(theme);
  }

  const encodedSearchQuery = encodeURIComponent(searchTerms.join(' ').split('-').join(' '));
  const page = Number(query.page);
  const offset = page > 1 ? ((page - 1) * Math.ceil(TEMPLATES_REQUEST_LIMIT)).toString() : '0';

  const queryObject = cleanQueryObject({
    ...query,
    q: encodedSearchQuery,
    standardTemplatesOffset: offset,
    premiumTemplatesOffset: offset,
    limit: String(TEMPLATES_REQUEST_LIMIT),
  });

  const finalQuery = new URLSearchParams(queryObject).toString();

  const url = `${process.env.REACT_APP_API_URL}/web-search/template/?${decodeURIComponent(
    finalQuery,
  )}`;

  const res = await fetch(url, {
    headers,
  });

  if (!res.ok) {
    throw new Error(`Status error fetching ${finalQuery}: ${res.status}`);
  }

  return res.json();
}
